<template>
  <v-layout>
    <v-container grid-list-md>
      <v-card>
        <div v-if="!stock_items" class="text-center">
          <p>
            <em>Loading...</em>
          </p>
          <h1>
            <icon icon="spinner" pulse />
          </h1>
        </div>
        <v-card-text v-if="stock_items">
          <!--dialog form to add and edit stock begins-->
          <modalDialog ref="stockfm">
            <template v-slot:modal-title>{{ fm_title }}</template>

            <template v-slot:modal-content>
              <v-card>
                <v-card-text>
                  <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                          label="Item Name*"
                          v-model="new_stock_model.name"
                          :rules="valid_rules.required"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          label="Item Code*"
                          v-model="new_stock_model.code"
                          :rules="itemCodeRule"
                          :readonly="ro"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          label="Description"
                          v-model="new_stock_model.description"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          label="Quantity*"
                          v-model="new_stock_model.quantity"
                          :rules="valid_rules.required"
                          type="number"
                          step="any"
                          @keydown="editedquan = true"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 v-if="editedIndex > -1 && editedquan">
                        <v-text-field
                          label="Reason for quantity change"
                          v-model="new_stock_model.qcr"
                          :rules="valid_rules.required"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          label="Purchase Price"
                          placeholder="price at which you bought item"
                          v-model="new_stock_model.pur_price"
                          :rules="valid_rules.required"
                          type="number"
                          step="any"
                          v-if="
                            current_user.user_details &&
                            current_user.user_details.role === 'administrator'
                          "
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          label="Selling Price"
                          placeholder="price at which you want to sell item"
                          v-model="new_stock_model.unit_price"
                          :rules="valid_rules.required"
                          type="number"
                          step="any"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <p>Item expires?</p>
                        <v-radio-group v-model="item_expires">
                          <v-radio label="Yes" value="y"></v-radio>
                          <v-radio label="No" value="n"></v-radio>
                        </v-radio-group>
                      </v-flex>

                      <v-flex xs12 v-if="item_expires == 'y'">
                        <p>Expiry Date:</p>
                        <v-date-picker
                          v-model="new_stock_model.expiry_date"
                          :landscape="true"
                          :reactive="true"
                          :full-width="true"
                          :show-current="false"
                        ></v-date-picker>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-card-text>
              </v-card>
            </template>

            <template v-slot:modal-actions>
              <v-btn class="error" text @click.stop="closeSForm()">Close</v-btn>
              <v-btn class="success" text @click="savestock()">Save</v-btn>
            </template>
          </modalDialog>
          <!--dialog form to add and edit stock ends-->
          <v-btn
            color="primary"
            style="margin-bottom: 10px"
            @click="openSForm()"
          >
            <v-icon>add</v-icon>Add Item
          </v-btn>

          <h4 style="text-align: right; color: #757575">
            Stock Summary: TPP: GHS{{ tpptsp.tpp | currency }} | TSP: GHS{{
              tpptsp.tsp | currency
            }}
          </h4>
          <v-layout row wrap>
            <v-flex xs12 sm12>
              <v-card>
                <v-card-title style="background: #eee">
                  <h4 style="text-align: center">Items</h4>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-card-title>
                <v-card-text>
                  <v-data-table
                    :headers="
                      current_user.user_details &&
                      current_user.user_details.role === 'administrator'
                        ? sitems_headers
                        : sitems_headers2
                    "
                    :items="stock_items"
                    class="elevation-0"
                    :search="search"
                    :loading="loading"
                  >
                    <template v-slot:item.sn="{ item, index }">
                      {{ index + 1 }}
                    </template>

                    <template v-slot:item.description="{ item }">
                      {{ item.description ? item.description : "N/A" }}
                    </template>

                    <template v-slot:item.expiry_status="{ item }">
                      <v-chip :color="isExpired(item.expiry_date) ? 'error':'transparent'">
                         {{ isExpired(item.expiry_date) ? "Expired" : "Good" }}
                      </v-chip>
                    </template>

                    <template v-slot:item.qty="{ item }">
                      <v-chip :color="item.quantity < 10 ? 'warning':'#fff'">
                        {{Number(item.quantity).toLocaleString() }}
                      </v-chip>
                     
                    </template>

                    <template v-slot:item.purprice = {item}>
                      <td
                        v-if="
                          current_user.user_details &&
                          current_user.user_details.role === 'administrator'
                        "
                      >
                        {{ parseFloat(item.pur_price) | currency }}
                      </td>
                    </template>

                     <template v-slot:item.unitprice = {item}>
                     
                        {{ parseFloat(item.unit_price) | currency }}
                  
                    </template>

                      <template v-slot:item.totalsold = {item}>
                     
                        {{ Number(item.sales_count).toLocaleString() }}
                  
                    </template>

                      <template v-slot:item.toi = {item}>
                     
                        {{ parseFloat(item.sale_sum) | currency }}
                  
                    </template>

                     <template v-slot:item.actions = {item,index}>
                          <v-layout row wrap>
                          <v-flex xs6>
                            <v-btn
                              text
                              icon
                              color="blue"
                              @click.native="editstock(item)"
                            >
                              <v-icon>edit</v-icon>
                            </v-btn>
                          </v-flex>

                          <v-flex xs6>
                            <v-btn
                              text
                              icon
                              color="pink"
                              @click.native="
                                deletestock(item, index)
                              "
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                       
                  
                    </template>

                    <!-- <template v-slot:items="props">
                      <td>{{ props.index + 1 }}</td>
                      <td>{{ props.item.name }}</td>
                      <td class="text-xs-center">{{ props.item.code }}</td>
                      <td class="text-xs-center">
                        {{
                          props.item.description
                            ? props.item.description
                            : "N/A"
                        }}
                      </td>
                      <td
                        class="text-xs-center"
                        v-bind:style="[
                          isExpired(props.item.expiry_date)
                            ? { background: 'red' }
                            : {},
                        ]"
                      >
                        {{
                          isExpired(props.item.expiry_date) ? "Expired" : "Good"
                        }}
                      </td>
                      <td
                        class="text-xs-center"
                        v-bind:style="[
                          props.item.quantity < 10
                            ? { background: 'pink' }
                            : {},
                        ]"
                      >
                        {{ props.item.quantity }}
                      </td>
                      <td
                        class="text-xs-center"
                        v-if="
                          current_user.user_details &&
                          current_user.user_details.role === 'administrator'
                        "
                      >
                        {{ props.item.pur_price | currency }}
                      </td>
                      <td class="text-xs-center">
                        {{ props.item.unit_price | currency }}
                      </td>
                      <td class="text-xs-center">
                        {{
                          props.item.sales_count ? props.item.sales_count : 0
                        }}
                      </td>
                      <td class="text-xs-center">
                        {{
                          props.item.sale_sum
                            ? props.item.sale_sum
                            : 0 | currency
                        }}
                      </td>
                      <td class="text-xs-center">
                        <v-layout row wrap>
                          <v-flex xs6>
                            <v-btn
                              flat
                              icon
                              color="blue"
                              @click.native="editstock(props.item)"
                            >
                              <v-icon>edit</v-icon>
                            </v-btn>
                          </v-flex>

                          <v-flex xs6>
                            <v-btn
                              flat
                              icon
                              color="pink"
                              @click.native="
                                deletestock(props.item, props.index)
                              "
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </td>
                    </template> -->
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
      <snackbar ref="sb"></snackbar>
    </v-container>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import modalDialog from "../shared/modal_dialog";
import ItemService from "../../services/item-service";
import snackbar from "../shared/snackbar";

export default {
  components: {
    modalDialog,
    snackbar,
  },

  data() {
    return {
      valid: true,
      lazy: false,
      ro: false,
      valid_rules: {
        required: [(v) => !!v || "this field is required"],
      },
      editedquan: false,
      item_expires: "n",
      editedItemOldCode: "",
      search: "",
      fm_title: "",
      editedIndex: -1,
      sitems_headers: [
        {
          text: "SN",
          align: "center",
          sortable: false,
          value: "sn",
        },
        {
          text: "ITEM NAME",
          align: "center",
          sortable: true,
          value: "name",
        },
        ,
        {
          text: "ITEM CODE",
          align: "center",
          sortable: false,
          value: "code",
        },
        {
          text: "DESCRIPTION",
          align: "center",
          sortable: false,
          value: "description",
        },
        {
          text: "EXPIRY STATUS",
          align: "center",
          sortable: false,
          value: "expiry_status",
        },
        {
          text: "QTY. IN STOCK",
          align: "center",
          sortable: false,
          value: "qty",
        },
        {
          text: "PURCHASE PRICE",
          align: "center",
          sortable: false,
          value: "purprice",
        },
        {
          text: "SELLING PRICE",
          align: "center",
          sortable: false,
          value: "unitprice",
        },
        {
          text: "TOTAL SOLD",
          align: "center",
          sortable: false,
          value: "totalsold",
        },
        {
          text: "TOTAL EARNED ON ITEM",
          align: "center",
          sortable: false,
          value: "toi",
        },
        {
          text: "ACTIONS",
          align: "center",
          sortable: false,
          value: "actions",
        },
      ],
      sitems_headers2: [
        {
          text: "SN",
          align: "center",
          sortable: false,
          value: "sn",
        },
        {
          text: "ITEM NAME",
          align: "center",
          sortable: true,
          value: "name",
        },
        ,
        {
          text: "ITEM CODE",
          align: "center",
          sortable: false,
          value: "code",
        },
        {
          text: "DESCRIPTION",
          align: "center",
          sortable: false,
          value: "description",
        },
        {
          text: "EXPIRY STATUS",
          align: "center",
          sortable: false,
          value: "expiry_date",
        },
        {
          text: "QTY. IN STOCK",
          align: "center",
          sortable: false,
          value: "qty",
        },
        // {
        //   text: "PURCHASE PRICE",
        //   align: "center",
        //   sortable: false,
        //   value: "purprice"
        // },
        {
          text: "SELLING PRICE",
          align: "center",
          sortable: false,
          value: "unitprice",
        },
        {
          text: "TOTAL SOLD",
          align: "center",
          sortable: false,
          value: "totalsold",
        },
        {
          text: "TOTAL EARNED ON ITEM",
          align: "center",
          sortable: false,
          value: "toi",
        },
        {
          text: "ACTIONS",
          align: "center",
          sortable: false,
          value: "actions",
        },
      ],
      new_stock_model: {
        name: "",
        code: "",
        description: "",
        quantity: "0",
        pur_price: "0.00",
        unit_price: "0.00",
        expiry_date: "",
        qcr: "", //quantity change reason
      },
      new_stock_model_dup: {
        name: "",
        code: "",
        description: "",
        quantity: "",
        pur_price: "",
        unit_price: "",
        expiry_date: "",
      },
    };
  },

  methods: {
    isUpdateAndChangeQuan() {
      if (this.editedIndex > -1) {
        return true;
      } else {
        return true;
      }
    },
    isExpired(date) {
      return moment(date).isBefore(new Date()) ? true : false;
    },
    addstock() {
      var sb = this.$refs.sb;
      this.$store.dispatch("Items/add", this.new_stock_model);

      if (this.iterrors == null) {
        this.snackbarconf(sb, "Item added successfully.", "success");
        this.new_stock_model = {
          name: "",
          code: "",
          description: "",
          quantity: "0",
          pur_price: "0.00",
          unit_price: "0.00",
          expiry_date: "",
        };
      } else {
        this.snackbarconf(sb, "Sorry, new item could not be added.", "error");
      }
    },
    deletestock(item, index) {
      var sb = this.$refs.sb;
      if (confirm("Are you sure you want to delete this stock?")) {
        this.$store.dispatch("Items/delete", { item, index });

        if (this.iterrors == null) {
          this.snackbarconf(sb, "Item deleted successfully.", "success");
        } else {
          this.snackbarconf(sb, "Sorry, item could not be deleted.", "error");
        }
      }
    },
    editstock(item) {
      this.ro = true;
      this.editedIndex = this.stock_items.indexOf(item);
      this.new_stock_model = Object.assign({}, item);
      this.editedItemOldCode = this.new_stock_model.code;
      if (this.new_stock_model.expiry_date) {
        this.item_expires = "y";
      }

      // console.log(this.selectedStockGroup);
      this.openSForm();
    },
    updatestock(item, index) {
      //console.log("errrossss",this.iterrors )
      var sb = this.$refs.sb;
      this.$store.dispatch("Items/update", { index, item });
      if (this.iterrors == null) {
        this.snackbarconf(sb, "Item updated successfully.", "success");
        this.closeSForm();
      } else {
        this.snackbarconf(
          sb,
          "Sorry, item update was not successful.",
          "error"
        );
      }
    },
    savestock() {
      if (this.$refs.form.validate()) {
        //decides between editing stock info or saving stock info
        if (this.editedIndex > -1) {
          this.updatestock(this.new_stock_model, this.editedIndex);
        } else {
          this.addstock();
        }
      }
    },
    snackbarconf(snackbar, message, color) {
      snackbar.text = message;
      snackbar.color = color;
      snackbar.snackbar = true;
    },

    openSForm() {
      var vm = this;
      if (this.editedIndex > -1) {
        this.fm_title = "Edit Item";
      } else {
        this.fm_title = "New Item";
      }
      vm.$refs.stockfm.IsPersistent();

      vm.$refs.stockfm.open();
    },
    closeSForm() {
      var vm = this;
      vm.new_stock_model = {
        name: "",
        code: "",
        description: "",
        quantity: "0",
        pur_price: "0.00",
        unit_price: "0.00",
        expiry_date: "",
        qcr: "", //quantity change reason
      };
      this.editedIndex = -1;
      this.editedItemOldCode = "";
      this.item_expires = "n";
      this.ro = false;
      this.editedquan = false;
      vm.$refs.stockfm.close();
    },
  },

  computed: {
    ...mapGetters({
      stock_items: "Items/ITEMS",
      current_user: "Auth/CURRENT_USER",
      iterrors: "Items/ITEM_ERROR",
      loading: "Items/ITEMS_LOADING",
    }),
    tpptsp() {
      let data = {
        tpp: 0,
        tsp: 0,
      };

      if (this.stock_items) {
        data.tpp = this.stock_items.reduce((sum, itm) => {
          return (sum += parseFloat(itm.pur_price) * parseFloat(itm.quantity));
        }, 0);

        data.tsp = this.stock_items.reduce((sum, itm) => {
          return (sum += parseFloat(itm.unit_price) * parseFloat(itm.quantity));
        }, 0);
      }

      return data;
    },
    itemCodeRule() {
      let codeCheck = this.stock_items.filter(
        (x) => x.code.toLowerCase() == this.new_stock_model.code.toLowerCase()
      );
      //let isEditNCodeExist = (codeCheck && this.editedIndex>=0) && codeCheck[0].code == this.editedItemOldCode? false : true; //checking to see if during editing an item was found with same code entered upon code change

      return [
        this.new_stock_model.code != "" || "this field is required",
        codeCheck.length == 0 ||
          this.editedIndex >= 0 ||
          "item code already exist",
      ];
    },
  },

  created() {
    this.$store.dispatch("Items/getAll");
    console.log(this.stock_items)
  },
  watch: {
    item_expires(val) {
      val == "n" ? (this.new_stock_model.expiry_date = "") : "";
      //alert(this.new_stock_model.exp_date)
    },
  },
};
</script>